<div class="form-group">
  <input [class.form-error]="errorMsg !== '' || OperErrMsg !== ''" class="form-control" type="tel"
    [(ngModel)]="mobileNumber" maxlength="11" autocomplete="mobile number" (keyup)="checkMobilePattern()"
    (blur)="emitValue()" required>
  <span class="floating-label">شماره موبایل</span>
  <span class="star">*</span>
  <span *ngIf="errorMsg" class="errorInput">{{errorMsg}}</span>
  <span *ngIf="OperErrMsg && !errorMsg" class="errorInput">{{OperErrMsg}}</span>
</div>